import React from "react";
import Footer from "../../Components/Footer";
import { motion } from "framer-motion";
import Header from "../../Components/Header";
import ContactUsInitialSection from "./Sections/ContactUsInitial/ContactUsInitial";
import WorkedOnSection from "../../Components/WorkedOnSection";
import GradientGlowDivider from "../../Components/GradientGlowDivider";

const ContactUsPage = () => {
  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div className="sticky md:static top-0 md:top-auto z-50 md:z-0 bg-app-background md:bg-transparent">
        <Header />
        <div className="w-[90%] mx-auto hidden md:block">
          <GradientGlowDivider />
        </div>
      </div>
      <ContactUsInitialSection />
      <WorkedOnSection
        title="See what we have worked on"
        className="md:mt-20 !pb-0 md:pb-40"
        showExploreMore={true}
      />
      <Footer className="mt-[0%]" />
    </motion.div>
  );
};

export default ContactUsPage;
